import { state } from "./state";
import { defineStoreActions } from "~/stores";
import { id } from "./id";
import { getters } from "./getters";

export const actions = defineStoreActions(
  {
    id,
    state,
    getters,
  },
  {
    setRedirectUrl(url: string) {
      const redirectCookie = useCookie("redirect-url");
      redirectCookie.value = url;
    },
    async handleRedirection(defaultUrl = "/") {
      const redirectCookie = useCookie("redirect-url");
      const url = redirectCookie.value ? redirectCookie.value : defaultUrl;
      navigateTo(url);
      redirectCookie.value = "";
    },
  },
);
